import React from 'react';
import FormModel from "../../common/form-model-manager";
import FormFieldError from "../../common/form-error/form-field-error";
import FieldProto from "../../../fields3/proto/field-proto";

type Props = {
    className?      : string

    form?          : FormModel
    field?         : FieldProto    // now mandatory

    columnType?     : 'default'
    label           : string
    labelClass?     : string
    elementClass?   : string

    onDelete?       : callback
    children?       : any
}


export default function FormColumn(props:Props) {

    const elementClasses = Classes("m-t-8 w-100-percent", props.elementClass, {
        // 'txt-36': props.columnType === 'text',
        // 'txt-multiline': props.columnType === 'text-multiline',
    })

    return (
        <div className={Classes("flex-column-left-top", props.className)}>
            <div className={Classes("ui5-txt-not-important", props.labelClass)}>{props.label}</div>
            <div className={elementClasses}>
                {props.onDelete &&
                    <div className="ui5-field-with-delete-on-hover">
                        {props.children}
                        <div className="ui5-ico-trash red s-14" onClick={props.onDelete}/>
                    </div>}

                {!props.onDelete && props.children}


                {props.field && props.form && <FormFieldError form={props.form} field={props.field} />}

            </div>
        </div>
    );
}
